import { render, staticRenderFns } from "./IndexMain.vue?vue&type=template&id=74a3eebe&"
import script from "./IndexMain.vue?vue&type=script&lang=js&"
export * from "./IndexMain.vue?vue&type=script&lang=js&"
import style0 from "./IndexMain.vue?vue&type=style&index=0&id=74a3eebe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports